<template>
  <b-overlay :show="loading">
    <b-card
      v-if="series"
      class="earnings-card"
    >
      <b-row>
        <b-col cols="6">
          <b-card-title class="mb-1">
            فروش
          </b-card-title>
          <div class="font-small-2">
            از ابتدا ماه جاری
          </div>
          <h5 class="mb-1">
            {{ totalEarn | price }}
          </h5>
          <b-card-text class="text-muted font-small-2">
            <span> فروش ماه قبل در روز مشابه</span><span class="font-weight-bolder">{{ '  ' }}{{ sameDayInLastMonth | price }}</span>
          </b-card-text>
        </b-col>
        <b-col cols="6">
          <!-- chart -->
          <vue-apex-charts
            v-if="showChart"
            ref="chart"
            height="120"
            :options="earningsChart.chartOptions"
            :series="series"
          />
        </b-col>
      </b-row>
    </b-card>
  </b-overlay>
</template>

<script>
import {
  BCard, BRow, BCol, BCardTitle, BCardText,
} from 'bootstrap-vue'
import VueApexCharts from 'vue-apexcharts'
import { $themeColors } from '@themeConfig'

const $earningsStrokeColor2 = '#28c76f66'
const $earningsStrokeColor3 = '#28c76f33'
export default {
  name: 'EarningsCurrentMonth',
  components: {
    BCard,
    BRow,
    BCol,
    BCardTitle,
    BCardText,
    VueApexCharts,
  },
  data() {
    return {
      totalEarn: 0,
      sameDayInLastMonth: 0,
      series: [],
      loading: true,
      showChart: false,
      earningsChart: {
        chartOptions: {
          chart: {
            type: 'donut',
            toolbar: {
              show: false,
            },
            fontFamily: 'IranSans',
          },
          dataLabels: {
            enabled: false,
          },
          legend: { show: false },
          comparedResult: [2, -3, 8],
          labels: [],
          stroke: { width: 0 },
          colors: [$earningsStrokeColor2, $earningsStrokeColor3, $themeColors.success],
          grid: {
            padding: {
              right: -20,
              bottom: -8,
              left: -20,
            },
          },
          plotOptions: {
            pie: {
              startAngle: -10,
              donut: {
                labels: {
                  fontFamily: 'IranSans',
                  show: true,
                  name: {
                    offsetY: 15,
                  },
                  value: {
                    offsetY: -15,
                    formatter(val) {
                      // eslint-disable-next-line radix
                      return `${parseInt(val)}%`
                    },
                  },
                  total: {
                    show: true,
                    formatter(val) {
                      return Math.max(...val.globals.series)
                    },
                    label: '',
                  },
                },
              },
            },
          },
          responsive: [
            {
              breakpoint: 1325,
              options: {
                chart: {
                  height: 100,
                },
              },
            },
            {
              breakpoint: 1200,
              options: {
                chart: {
                  height: 120,
                },
              },
            },
            {
              breakpoint: 1045,
              options: {
                chart: {
                  height: 100,
                },
              },
            },
            {
              breakpoint: 992,
              options: {
                chart: {
                  height: 120,
                },
              },
            },
          ],
        },
      },
    }
  },
  created() {
    const gatheringData = []
    this.howMuchEarn().then(() => {
      this.enums('products').forEach(product => {
        gatheringData.push(this.howMuchEarnAsOneMonthDiet(product.key))
      })
      Promise.all(gatheringData).then(charts => {
        const series = []
        const labels = []
        charts.forEach(chart => {
          series.push(parseInt(chart.result, 0))
          labels.push(this.enums('products', 'key', chart.type, 'text'))
        })
        this.series.push(...series)
        this.earningsChart.chartOptions.labels.push(...labels)
        // const max = Math.max(...series)
        // const index = series.indexOf(max)
        // console.log(labels[index])
        // this.earningsChart.chartOptions.plotOptions.pie.donut.labels.total.label = labels[index]
      }).finally(() => { this.loading = false; this.showChart = true })
    })
    this.howMuchEarnLastMonth()
  },
  methods: {
    howMuchEarn() {
      return new Promise(resolve => {
        const fromDate = this.$moment().startOf('jMonth').format('YYYY/MM/DD')
        const toDate = this.$moment().format('YYYY/MM/DD')
        this.$http.post(this.$api.report.sellReport, {
          FromDate: fromDate,
          ToDate: toDate,
          DietDurationPriceId: [],
          Bank: [],
          IsPaid: true,
          CouponId: [],
        }).then(response => {
          this.totalEarn = response.data.reduce((total, res) => (total + res.Price), 0)
          resolve('ok')
        })
      })
    },
    howMuchEarnLastMonth() {
      const fromDate = this.$moment().subtract(1, 'months').startOf('jMonth').format('YYYY/MM/DD')
      const toDate = this.$moment().subtract(1, 'months').format('YYYY/MM/DD')
      this.$http.post(this.$api.report.sellReport, {
        FromDate: fromDate,
        ToDate: toDate,
        DietDurationPriceId: [],
        Bank: [],
        IsPaid: true,
        CouponId: [],
      }).then(response => {
        this.sameDayInLastMonth = response.data.reduce((total, res) => (total + res.Price), 0)
      })
    },
    howMuchEarnAsOneMonthDiet(type) {
      return new Promise(resolve => {
        const fromDate = this.$moment().startOf('jMonth').format('YYYY/MM/DD')
        const toDate = this.$moment().format('YYYY/MM/DD')
        this.$http.post(this.$api.report.sellReport, {
          FromDate: fromDate,
          ToDate: toDate,
          DietDurationPriceId: this.enums('products', 'key', type, 'value'),
          Bank: [],
          IsPaid: true,
          CouponId: [],
        }).then(response => {
          const result = (response.data.reduce((total, res) => (total + res.Price), 0) / this.totalEarn) * 100
          resolve({ result, type })
        })
      })
    },
  },
}
</script>
`
